/*eslint-disable no-unused-vars */
import React, { useState, createRef } from 'react';
import { useSelector } from 'react-redux';
import { Formik } from 'formik';
import * as yup from 'yup';
import { Col, Container, Row, Form } from 'react-bootstrap';
import MasterPermissions from '../../api/MasterPermissions';
import GenericButton from '../../../Components/GenericButton/GenericButton';
import AutoSuggestionSelectComponent from '../../components/common/AutoSuggestSelect/Select';
import { useTranslation } from 'react-i18next';
import DatePicker from '../common/DatePicker';
import moment from 'moment';
//import { ActionMenus } from '../common/ActionMenu';
//import CarrotDownIcon from 'src/Admin/img/search-claims/carrot-down';

/*const ActionMenuItem = ({ label, onClick, className }) => {
  return (
    <div className={`criteria-menu-item ${className}`}>
      <GenericButton
        className="pl-0 criteria-menu-item-btn"
        variant="link"
        onClick={onClick}
      >
        {label}
      </GenericButton>
    </div>
  );
};*/

const memberTypeOptions = () => {
  const optionsForMemberType = [];
  if (MasterPermissions.CheckPermission('Search for Member')) {
    optionsForMemberType.push({ label: 'Member', value: 'Member' });
  }
  if (MasterPermissions.CheckPermission('Search for Dependent')) {
    optionsForMemberType.push({ label: 'Dependent', value: 'Dependent' });
  }
  if (
    MasterPermissions.CheckPermission('Search for Member') &&
    MasterPermissions.CheckPermission('Search for Dependent')
  ) {
    optionsForMemberType.push({ label: 'Both', value: 'Both' });
  }
  return optionsForMemberType;
};

/*const MemberTypeContextMenu = ({ selectedValue, onChangeItem }) => {
  const actionMenuRef = createRef(null);

  return (
    <ActionMenus
      ref={actionMenuRef}
      MenuLabelComponent={() => (
        <GenericButton
          className="pl-0 add-search-criteria-btn"
          variant="link"
          onClick={() => {}}
        >
          {selectedValue || 'Member Type'} <CarrotDownIcon />
        </GenericButton>
      )}
      containerClassName="criteria-menu-container member-types-menu-container"
      menuItemContainerClassName="criteria-menu-item-container member-types-menu-item-container"
      menuItems={memberTypeOptions().map((menu) => {
        return () => (
          <ActionMenuItem
            label={menu.label}
            onClick={() => {
              onChangeItem(menu.value);
            }}
            className="member-type-menu-item"
          />
        );
      })}
    />
  );
};*/

const MemberAdvancedSearch = ({
  onHandleAdvanceSearch,
  setSearchButtonClicked,
  additionalSearchStateValues,
}) => {
  const { t } = useTranslation();
  const { userData } = useSelector((state) => state.user);
  const { Default_Time_Format } = useSelector(
    ({ app }) => app.appConfigs.Time_Setting || 'MM-dd-yyyy',
  );
  const isSuperUser = userData?.SuperUser;
  console.log('additionalSearchStateValues', additionalSearchStateValues);
  const [memberTypeValue, setMemberTypeValue] = useState(
    additionalSearchStateValues?.MemberType
      ? additionalSearchStateValues?.MemberType
      : '',
  );
  const [dobValue, setDobValue] = useState(false);
  const [displayDate, setDisplayDate] = useState(null);

  console.log('additionalSearchStateValues memberTypeValue', memberTypeValue);
  const memberIDLabel = [];

  const firstNamePermission = MasterPermissions.CheckPermission('First Name');
  const lastNamePermission = MasterPermissions.CheckPermission('Last Name');
  const dobPermission = MasterPermissions.CheckPermission('Date of Birth');
  const memberIDPermission = MasterPermissions.CheckPermission('Member ID');
  const ssnPermission = MasterPermissions.CheckPermission('SSN');
  const emailIDPermission =
    MasterPermissions.CheckPermission('Primary Email ID');
  const contactNumberPermission =
    MasterPermissions.CheckPermission('Phone number');
  const certificateNumerPermission =
    MasterPermissions.CheckPermission('Cert Number');
  const altId1Permission = MasterPermissions.CheckPermission('Alt ID 1');
  const altId2Permission = MasterPermissions.CheckPermission('Alt ID 2');
  const mandatoryMemberDetails = MasterPermissions.CheckPermission(
    'Mandatory Member Details',
  );
  const dependentPermission = MasterPermissions.CheckPermission(
    'Search for Dependent',
  );
  const memberPermission =
    MasterPermissions.CheckPermission('Search for Member');
  const patientTypePermission = memberPermission || dependentPermission;
  const ALPHAONLY = /^[A-Za-z ]*$/;
  const ONLYSPACES = /^(?!\s+$).*/;
  const ALPHANUMERICONLY = /^[A-Za-z0-9]*$/;
  const SSNNUMBERSONLY = /^[0-9-]*$/;
  const PHONENUMBERSONLY = /^[0-9( ))]*$/;
  //const EMAILREGEX = /^[\w-\\.]+@([\w-]+\.)+[\w-]{2,4}$/;

  //const countryCodeList = [{ label: '+1', value: '+1' }];

  if (
    memberIDPermission ||
    isSuperUser ||
    !mandatoryMemberDetails ||
    (!certificateNumerPermission && !altId1Permission && !altId2Permission)
  ) {
    memberIDLabel.push(
      t('admin.pages.manage_member.additional_search_fields.member_id'),
    );
  }
  if (certificateNumerPermission) {
    memberIDLabel.push(
      t('admin.pages.manage_member.additional_search_fields.cert_number'),
    );
  }
  if (altId1Permission) {
    memberIDLabel.push(
      t('admin.pages.manage_member.additional_search_fields.alt_id_1'),
    );
  }
  if (altId2Permission) {
    memberIDLabel.push(
      t('admin.pages.manage_member.additional_search_fields.alt_id_2'),
    );
  }

  const InitialFormatPhone = (val) => {
    const input = val.replace(/\D/g, '').substring(0, 10);
    const first = input.substring(0, 3);
    const middle = input.substring(3, 6);
    const last = input.substring(6, 10);
    if (input.length > 6) {
      return `(${first}) ${middle} ${last}`;
    } else if (input.length > 3) {
      return `(${first}) ${middle}`;
    } else if (input.length > 0) {
      return `(${first})`;
    }
  };

  const formatPhone = (e) => {
    const target = e.target;
    const input = e.target.value.replace(/\D/g, '').substring(0, 10);
    const first = input.substring(0, 3);
    const middle = input.substring(3, 6);
    const last = input.substring(6, 10);
    if (input.length > 6) {
      target.value = `(${first}) ${middle} ${last}`;
    } else if (input.length > 3) {
      target.value = `(${first}) ${middle}`;
    } else if (input.length > 0) {
      target.value = `(${first})`;
    }
  };

  /*const initialFormatSSN = (val) => {
    const input = val.replace(/\D/g, '').substring(0, 9);
    const first = input.substring(0, 3);
    const middle = input.substring(3, 5);
    const last = input.substring(5, 9);
    if (input.length > 5) {
      return `${first}-${middle}-${last}`;
    } else if (input.length > 3) {
      return `${first}-${middle}`;
    } else if (input.length > 0) {
      return `${first}`;
    }
  };

  const formatSSN = (e) => {
    console.log('e::::::::::: ', e);
    const target = e.target;
    const input = e.target.value.replace(/\D/g, '').substring(0, 9);
    const first = input.substring(0, 3);
    const middle = input.substring(3, 5);
    const last = input.substring(5, 9);
    if (input.length > 5) {
      target.value = `${first}-${middle}-${last}`;
    } else if (input.length > 3) {
      target.value = `${first}-${middle}`;
    } else if (input.length > 0) {
      target.value = `${first}`;
    }
  };*/

  const unFormatPhoneNumber = (phone) => {
    if (phone !== null || phone.toString() !== '') {
      return phone
        .toString()
        .replace(/\D+/g, '')
        .replace(/(\d{3})(\d{3})(\d{4})/, '$1$2$3');
    }
  };

  /*const unFormatSSN = (ssn) => {
    if (ssn !== null || ssn.toString() !== '') {
      return ssn
        .toString()
        .replace(/\D+/g, '')
        .replace(/(\d{3})(\d{2})(\d{4})/, '$1$2$3');
    }
  };*/

  const submitIsEnabled = (values, errors) => {
    if (
      ((memberIDPermission ||
        certificateNumerPermission ||
        altId1Permission ||
        altId2Permission ||
        !mandatoryMemberDetails) &&
        !values.MemberID) ||
      (firstNamePermission && !isSuperUser && !values.FirstName) ||
      (lastNamePermission && !isSuperUser && !values.LastName) ||
      (dobPermission && !isSuperUser && !values.DOB) ||
      (ssnPermission && !isSuperUser && !values.SSN) ||
      (contactNumberPermission && !isSuperUser && !values.ContactNumber) ||
      (emailIDPermission && !isSuperUser && !values.EmailID)
    ) {
      return false;
    }
    if (
      ((memberIDPermission ||
        certificateNumerPermission ||
        altId1Permission ||
        altId2Permission ||
        !mandatoryMemberDetails) &&
        errors.MemberID) ||
      errors.FirstName ||
      errors.LastName ||
      errors.DOB ||
      errors.SSN ||
      errors.ContactNumber ||
      errors.EmailID
    ) {
      return false;
    }
    return true;
  };

  const schema = yup.object({
    MemberID: yup
      .string()
      .ensure()
      .when('required', {
        is: () =>
          memberIDPermission === true ||
          certificateNumerPermission ||
          altId1Permission ||
          altId2Permission ||
          !mandatoryMemberDetails,
        then: () =>
          yup
            .string()
            .max(30, ' Enter maximum 30 characters only')
            .matches(
              ALPHANUMERICONLY,
              ' Invalid field - only Alphabets and Numbers allowed.',
            )
            .required(' Enter Member ID'),
        otherwise: () =>
          yup
            .string()
            .notRequired()
            .max(30, ' Enter maximum 30 characters only')
            .matches(
              ALPHANUMERICONLY,
              ' Invalid field - only Alphabets and Numbers allowed.',
            ),
      }),
    FirstName: yup
      .string()
      .ensure()
      .when('required', {
        is: () => firstNamePermission === true && !isSuperUser,
        then: () =>
          yup
            .string()
            .max(35, ' Enter maximum 35 characters only')
            .matches(
              ALPHANUMERICONLY,
              ' Invalid field - only Alphabets and Numbers allowed.',
            )
            .required(' Enter First Name')
            .nullable()
            .matches(ONLYSPACES, ' Enter First Name'),
        otherwise: () =>
          yup
            .string()
            .notRequired()
            .max(35, ' Enter maximum 35 characters only')
            .matches(
              ALPHANUMERICONLY,
              ' Invalid field - only Alphabets and Numbers allowed.',
            ),
      }),
    LastName: yup
      .string()
      .ensure()
      .when('required', {
        is: () => lastNamePermission === true && !isSuperUser,
        then: () =>
          yup
            .string()
            .max(60, ' Enter maximum 60 characters only')
            .matches(
              ALPHANUMERICONLY,
              ' Invalid field - only Alphabets and Numbers allowed.',
            )
            .required(' Enter Last Name')
            .nullable()
            .matches(ONLYSPACES, ' Enter Last Name'),
        otherwise: () =>
          yup
            .string()
            .notRequired()
            .max(60, ' Enter maximum 60 characters only')
            .matches(
              ALPHANUMERICONLY,
              ' Invalid field - only Alphabets and Numbers allowed.',
            ),
      }),
    DOB: yup
      .string()
      .ensure()
      .when('required', {
        is: () => dobPermission === true && !isSuperUser,
        then: () =>
          yup
            .string()
            //.max( 60, ' Enter maximum 60 characters only' )
            .required(' Enter Date of Birth'),
        otherwise: () => yup.string().notRequired(),
      }),
    SSN: yup
      .string()
      .ensure()
      .when('required', {
        is: () => ssnPermission === true && !isSuperUser,
        then: () =>
          yup
            .string()
            .matches(
              ALPHANUMERICONLY,
              ' Invalid field - only Alphabets and Numbers allowed.',
            )
            .max(10, ' Maximum 10 characters are allowed')
            .required(' Enter SSN'),
        otherwise: () =>
          yup
            .string()
            .notRequired()
            .matches(
              ALPHANUMERICONLY,
              ' Invalid field - only Alphabets and Numbers allowed.',
            )
            .max(10, ' Maximum 10 characters are allowed'),
      }),
    EmailID: yup
      .string()
      .ensure()
      .when('required', {
        is: () => emailIDPermission === true && !isSuperUser,
        then: () =>
          yup
            .string()
            .email(' Enter Valid Email Address.')
            //.matches(EMAILREGEX, ' Enter Valid Email Address.')
            .required('Enter Email ID'),
        otherwise: () =>
          yup.string().notRequired().email(' Enter Valid Email Address.'),
      }),
    ContactNumber: yup
      .string()
      .ensure()
      .when('required', {
        is: () => contactNumberPermission === true && !isSuperUser,
        then: () =>
          yup
            .string()
            .matches(PHONENUMBERSONLY, ' Invalid field - only Numbers allowed.')
            .min(14, ' Enter correct Phone Number')
            .required('Enter Phone Number'),
        otherwise: () =>
          yup
            .string()
            .notRequired()
            .matches(PHONENUMBERSONLY, ' Invalid field - only Numbers allowed.')
            .min(14, ' Enter correct Phone Number'),
      }),
    /*MemberType: yup
      .string()
      .ensure()
      .when('required', {
        is: () => patientTypePermission === true && !isSuperUser,
        then: () => yup.string().required('Select Member Type'),
        otherwise: () => yup.string().notRequired(),
      }),*/
  });

  const handleMemberTypeSelection = (e) => {
    console.log('handleMemberTypeSelection', e.value);
    setMemberTypeValue(e.value);
  };

  console.log('memberTypeValue', memberTypeValue);

  const handleBlurDatePicker = (dateValue) => {
    if (dobPermission && !isSuperUser) {
      if (dateValue && dateValue !== '') {
        setDobValue(false);
      } else {
        setDobValue(true);
      }
    }
  };

  const selectedMemberType = memberTypeOptions().filter(
    (option) => option.value === memberTypeValue,
  );

  const {
    MemberID,
    FirstName,
    LastName,
    ContactNumber,
    DOB,
    EmailID,
    SSN,
    MemberType,
  } = additionalSearchStateValues;

  return (
    <div>
      <Container className="mtop30 activationCode personal-info">
        <Row className="h-100">
          <Col md={12} lg={12} sm={12} className="padding-0">
            <Formik
              validationSchema={schema}
              initialValues={{
                MemberID: MemberID || '',
                FirstName: FirstName || '',
                LastName: LastName || '',
                DOB: DOB || '',
                //SSN: SSN ? initialFormatSSN(SSN) : '',
                SSN: SSN || '',
                EmailID: EmailID || '',
                ContactNumber: ContactNumber
                  ? InitialFormatPhone(ContactNumber)
                  : '',
                MemberType: MemberType || '',
              }}
              onSubmit={(values, { resetForm }) => {
                const phoneNumberValue = unFormatPhoneNumber(
                  values.ContactNumber,
                );
                //const ssnValue = unFormatSSN(values.SSN);
                const submittedValues = {
                  ...values,
                  ContactNumber: phoneNumberValue,
                  //: ssnValue,
                  MemberType: memberTypeValue,
                };
                onHandleAdvanceSearch(submittedValues);
                //resetForm();
              }}
            >
              {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                touched,
                errors,
                isValid,
                handleReset,
                resetForm,
                setFieldValue,
                setFieldTouched,
              }) => {
                const submitEnabled = submitIsEnabled(values, errors);
                return (
                  <Form onSubmit={handleSubmit} className="border-right-after">
                    {/*<Row>
                      <Col md={6}></Col>
                      {patientTypePermission && (
                        <Col md={6} className="d-flex justify-content-end">
                          <MemberTypeContextMenu
                            onChangeItem={(val) => {
                              handleMemberTypeSelection(val);
                            }}
                            selectedValue={memberTypeValue || ''}
                          />
                        </Col>
                      )}
                          </Row>*/}
                    <Row>
                      <Col>
                        <div className="search-row-text">
                          {t(
                            'admin.pages.manage_member.member_additional_search_text',
                          )}
                        </div>
                      </Col>
                    </Row>
                    <Row className="mt-4">
                      {
                        /*memberIDPermission && (*/
                        <Col md={4} lg={4} sm={4}>
                          <Form.Group controlId="formBasicmemberid">
                            <Form.Label>
                              {memberIDLabel.join(' or ')}
                              {(memberIDPermission ||
                                certificateNumerPermission ||
                                altId1Permission ||
                                altId2Permission ||
                                !mandatoryMemberDetails) && (
                                <span
                                  aria-hidden={true}
                                  className="mandatory-field"
                                >
                                  *
                                </span>
                              )}
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="MemberID"
                              placeholder="Enter Member ID"
                              className=""
                              value={values.MemberID}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              isInvalid={touched.MemberID && errors.MemberID}
                              autoCorrect="off"
                              spellCheck="off"
                              autoFocus={false}
                              autoComplete="off"
                            />

                            <Form.Control.Feedback type="invalid">
                              <span role="alert">
                                {touched.MemberID && errors.MemberID}
                              </span>
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        /*)*/
                      }
                      {
                        /*firstNamePermission && (*/
                        <Col md={4} lg={4} sm={4}>
                          <Form.Group controlId="formBasicfname">
                            <Form.Label>
                              {t(
                                'admin.pages.manage_member.additional_search_fields.first_name',
                              )}{' '}
                              {firstNamePermission && !isSuperUser && (
                                <span
                                  aria-hidden={true}
                                  className="mandatory-field"
                                >
                                  *
                                </span>
                              )}
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="FirstName"
                              placeholder="Enter First Name"
                              className=""
                              value={values.FirstName}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              isInvalid={touched.FirstName && errors.FirstName}
                              autoCorrect="off"
                              spellCheck="off"
                              autoFocus={false}
                              autoComplete="off"
                            />

                            <Form.Control.Feedback type="invalid">
                              <span role="alert">
                                {touched.FirstName && errors.FirstName}
                              </span>
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        /*)*/
                      }
                      {
                        /*lastNamePermission && (*/
                        <Col md={4} lg={4} sm={4}>
                          <Form.Group controlId="formBasicLname">
                            <Form.Label>
                              {t(
                                'admin.pages.manage_member.additional_search_fields.last_name',
                              )}
                              {lastNamePermission && !isSuperUser && (
                                <span
                                  aria-hidden={true}
                                  className="mandatory-field"
                                >
                                  *
                                </span>
                              )}
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="LastName"
                              placeholder="Enter Last Name"
                              className=""
                              value={values.LastName}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              isInvalid={touched.LastName && errors.LastName}
                              autoCorrect="off"
                              spellCheck="off"
                              autoFocus={false}
                              autoComplete="off"
                            />

                            <Form.Control.Feedback type="invalid">
                              <span role="alert">
                                {touched.LastName && errors.LastName}
                              </span>
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        /*)*/
                      }
                      {dobPermission && (
                        <Col md={4} lg={4} sm={4}>
                          <Form.Group controlId="formBasicdob">
                            <Form.Label>
                              {t(
                                'admin.pages.manage_member.additional_search_fields.dob',
                              )}
                              {dobPermission && !isSuperUser && (
                                <span
                                  aria-hidden={true}
                                  className="mandatory-field"
                                >
                                  *
                                </span>
                              )}
                            </Form.Label>
                            {/*<Form.Control
                              type="date"
                              name="DOB"
                              placeholder="MM/DD/YYYY"
                              className=""
                              value={values.DOB}
                              max={new Date().toISOString().split('T')[0]}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              isInvalid={touched.DOB && errors.DOB}
                              autoCorrect="off"
                              spellCheck="off"
                              autoFocus={false}
                              autoComplete="off"
                            /> */}
                            <DatePicker
                              name={'DOB'}
                              showIcon={true}
                              isDOB={true}
                              value={values.DOB ? displayDate : null}
                              onBlur={() =>
                                handleBlurDatePicker(values.personal_dob)
                              }
                              onChange={(date) => {
                                if (date) {
                                  setFieldValue(
                                    'DOB',
                                    moment(date).format('YYYY-MM-DD'),
                                  );
                                  setDisplayDate(date);
                                  dobPermission &&
                                    !isSuperUser &&
                                    setDobValue(false);
                                } else {
                                  setFieldValue('DOB', '');
                                  dobPermission &&
                                    !isSuperUser &&
                                    setDobValue(true);
                                }
                              }}
                              errorClassName={
                                dobValue ? 'invalid-error-border' : ''
                              }
                            />
                            {dobValue && (
                              <div className="invalid-feedback-error">
                                <span role="alert">{errors.DOB}</span>
                              </div>
                            )}
                          </Form.Group>
                        </Col>
                      )}
                      {ssnPermission && (
                        <Col md={4} lg={4} sm={4}>
                          <Form.Group controlId="formBasicSSN">
                            <Form.Label>
                              {t(
                                'admin.pages.manage_member.additional_search_fields.ssn',
                              )}
                              {ssnPermission && !isSuperUser && (
                                <span
                                  aria-hidden={true}
                                  className="mandatory-field"
                                >
                                  *
                                </span>
                              )}
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="SSN"
                              placeholder="Enter SSN"
                              className=""
                              value={values.SSN}
                              maxLength={10}
                              //onKeyUp={(e) => formatSSN(e)}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              isInvalid={touched.SSN && errors.SSN}
                              autoCorrect="off"
                              spellCheck="off"
                              autoFocus={false}
                              autoComplete="off"
                            />

                            <Form.Control.Feedback type="invalid">
                              <span role="alert">
                                {touched.SSN && errors.SSN}
                              </span>
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                      )}
                      {contactNumberPermission && (
                        <Col md={4} lg={4} sm={4}>
                          <Form.Group controlId="formBasicContactNumber">
                            <Form.Label>
                              {t(
                                'admin.pages.manage_member.additional_search_fields.home_phone',
                              )}
                              {contactNumberPermission && !isSuperUser && (
                                <span
                                  aria-hidden={true}
                                  className="mandatory-field"
                                >
                                  *
                                </span>
                              )}
                            </Form.Label>
                            <div className="d-flex">
                              <div className="countrycode-width">
                                <Form.Control
                                  type="text"
                                  name="countryCode"
                                  placeholder=""
                                  className=""
                                  value="+1"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  autoCorrect="off"
                                  spellCheck="off"
                                  autoFocus={false}
                                  autoComplete="off"
                                  readOnly={true}
                                />
                              </div>
                              <div className="contact-number">
                                <Form.Control
                                  type="text"
                                  name="ContactNumber"
                                  placeholder="Enter Phone Number"
                                  className=""
                                  value={values.ContactNumber}
                                  maxLength={14}
                                  onKeyUp={(e) => formatPhone(e)}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  isInvalid={
                                    touched.ContactNumber &&
                                    errors.ContactNumber
                                  }
                                  autoCorrect="off"
                                  spellCheck="off"
                                  autoFocus={false}
                                  autoComplete="off"
                                />

                                <Form.Control.Feedback type="invalid">
                                  <span role="alert">
                                    {touched.ContactNumber &&
                                      errors.ContactNumber}
                                  </span>
                                </Form.Control.Feedback>
                              </div>
                            </div>
                          </Form.Group>
                        </Col>
                      )}
                      {emailIDPermission && (
                        <Col md={4} lg={4} sm={4}>
                          <Form.Group controlId="formBasicEmailID">
                            <Form.Label>
                              {t(
                                'admin.pages.manage_member.additional_search_fields.email_id',
                              )}
                              {emailIDPermission && !isSuperUser && (
                                <span
                                  aria-hidden={true}
                                  className="mandatory-field"
                                >
                                  *
                                </span>
                              )}
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="EmailID"
                              placeholder="Enter Email ID"
                              className=""
                              value={values.EmailID}
                              maxLength={255}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              isInvalid={touched.EmailID && errors.EmailID}
                              autoCorrect="off"
                              spellCheck="off"
                              autoFocus={false}
                              autoComplete="off"
                            />

                            <Form.Control.Feedback type="invalid">
                              <span role="alert">
                                {touched.EmailID && errors.EmailID}
                              </span>
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                      )}
                      {patientTypePermission && (
                        <Col md={4} lg={4} sm={4}>
                          <Form.Label className="mb-2">Member Type</Form.Label>
                          <AutoSuggestionSelectComponent
                            options={memberTypeOptions()}
                            name="MemberType"
                            placeholder="Select Member Type"
                            components={{
                              IndicatorSeparator: () => null,
                            }}
                            value={selectedMemberType || null}
                            onChange={(e) => {
                              const event = {
                                target: { name: 'MemberType', value: e },
                              };
                              handleChange(event);
                              handleMemberTypeSelection(e);
                            }}
                            fieldTouch={setFieldTouched}
                            isSearchable={false}
                            /*inputClassName={
                              touched.MemberType && errors.MemberType
                                ? 'select-invalid-error'
                                : ''
                            }
                            isInvalid={touched.MemberType && errors.MemberType}*/
                          />
                        </Col>
                      )}
                    </Row>
                    <Row className="">
                      <Col className="float-right text-right">
                        <GenericButton
                          type="button"
                          variant="link"
                          className="mt-4"
                          onClick={() => {
                            resetForm();
                            setMemberTypeValue('');
                            setSearchButtonClicked(false);
                          }}
                        >
                          Clear
                        </GenericButton>
                        <GenericButton
                          type="submit"
                          variant="primary"
                          disable={!submitEnabled}
                          buttonDisabled={!submitEnabled}
                          className="mt-4"
                        >
                          SEARCH
                        </GenericButton>
                      </Col>
                    </Row>
                  </Form>
                );
              }}
            </Formik>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
export default MemberAdvancedSearch;
